import type React from 'react';

const ACCENT_CLASSES: Record<
  'purple' | 'blue' | 'cyan' | 'green' | 'sky' | 'slate' | 'amber',
  string
> = {
  purple: 'bg-purple-50 border-purple-500 [&_.accent-bar]:bg-purple-500',
  blue: 'bg-blue-50 border-blue-400 [&_.accent-bar]:bg-blue-400',
  sky: 'bg-sky-50 border-sky-500 [&_.accent-bar]:bg-sky-500',
  cyan: 'bg-cyan-50 border-cyan-500 [&_.accent-bar]:bg-cyan-500',
  green: 'bg-green-50 border-green-500 [&_.accent-bar]:bg-green-500',
  slate: 'bg-slate-50 border-slate-500 [&_.accent-bar]:bg-slate-500',
  amber: 'bg-amber-50 border-amber-400 [&_.accent-bar]:bg-amber-400',
};

type TGradientPanelProps = {
  children: React.ReactNode;
  className?: string;
  accentColor?:
    | 'purple'
    | 'blue'
    | 'cyan'
    | 'green'
    | 'sky'
    | 'slate'
    | 'amber';
  accentSide?: 'top' | 'left';
};

export const GradientPanel: React.FC<TGradientPanelProps> = ({
  children,
  className = '',
  accentColor = 'blue',
  accentSide = 'top',
}) => {
  const accentBarClasses =
    accentSide === 'left'
      ? 'accent-bar absolute top-0 left-0 bottom-0 w-1'
      : 'accent-bar absolute top-0 left-0 right-0 h-1';

  return (
    <div
      className={`relative flex-shrink-0 rounded-2xl bg-gradient-to-b border-2 p-5 overflow-hidden ${ACCENT_CLASSES[accentColor]} ${className}`}>
      <div className={accentBarClasses} />
      {children}
    </div>
  );
};
